//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/popover'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/select_box'

//#endregion

import { ALARM_DEFINITION_SERVICE_NAME } from '../../../../../../services/alarm-definition'
import { AlarmDefinitionsSingleEditController } from './alarm-definitions-single-edit.controller'
import { GRID_SERVICE_NAME } from '../../../../../../services/grid'
import { REFERENCE_TYPE_SERVICE_NAME } from '../../../../../../services/reference-type'
import { USER_SESSION_SERVICE_NAME } from '../../../../../../services/user-session'
import { $SCOPE_SERVICE_NAME } from '../../../../../../services/system'

//#region Asset Imports

import './alarm-definitions-single-edit.scss'
import * as TEMPLATE from './alarm-definitions-single-edit.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitionsSingleEdit'

// #endregion

export class AlarmDefinitionsSingleEditComponent implements ng.IComponentOptions {
    restrict = 'E'

    bindings = {
        options: '<',
    } as { [index: string]: string }

    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ALARM_DEFINITION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        AlarmDefinitionsSingleEditController
    ]

    template = TEMPLATE
}
